var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 3.00016C18.3332 2.0835 17.5832 1.3335 16.6665 1.3335H3.33317C2.4165 1.3335 1.6665 2.0835 1.6665 3.00016M18.3332 3.00016V13.0002C18.3332 13.9168 17.5832 14.6668 16.6665 14.6668H3.33317C2.4165 14.6668 1.6665 13.9168 1.6665 13.0002V3.00016M18.3332 3.00016L9.99984 8.8335L1.6665 3.00016",
    stroke: "#828584",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5333c41980aaac7e744a6c87c4aecb67.svg";
export { ForwardRef as ReactComponent };